import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { generateSeo } from "@/lib/utils/seo";

const contactSearchSchema = z.object({
	plan: z.string().optional(),
});

export const Route = createFileRoute("/_main/contact")({
	validateSearch: (search) => contactSearchSchema.parse(search),
	head: () =>
		generateSeo({
			title: "Contact CraftLayer | Get a Quote for SEO & Web Development",
			description:
				"Looking for digital services in Bangalore? Contact CraftLayer for a free consultation on SEO, Social Media Marketing, Ads, or Website Development projects.",
			url: "/contact",
			keywords: [
				"contact CraftLayer",
				"hire web developers bangalore",
				"seo consultation",
				"digital marketing quote",
				"web design inquiry",
			],
		}),
});
